// extracted by mini-css-extract-plugin
export var linkContainer = "contact-module--linkContainer--jOkMD";
export var mailLink = "contact-module--mailLink--S+pbM";